import { CloseRounded, Delete } from '@mui/icons-material'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CancelButton, DeleteButton } from '../../../../shared/components/inputs'

interface DeleteBrandModalProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  isMobile: boolean
}

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: theme.shape.borderRadius
  }
}))

const DeleteBrandModal: React.FC<DeleteBrandModalProps> = ({ open, onClose, onConfirm, isMobile }) => {
  const { t } = useTranslation(['global'])

  return (
    <StyledDialog
      data-testid="removeBrandModal"
      open={open}
      fullWidth
      fullScreen={isMobile}
      maxWidth={isMobile ? undefined : 'sm'}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {t('delete')} {t('brand')}
          </Typography>
          <Button onClick={onClose} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <Typography>{t('confirm-delete')}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose}>{t('cancel')}</CancelButton>
        <DeleteButton autoFocus id="btn-handleldelete" endIcon={<Delete />} onClick={onConfirm}>
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default DeleteBrandModal
